/**
 * Fehler aus einer REST-Anfrage.
 */
export class Api_Error extends Error {

    /** Maschinenlesbarer Fehlercode, z.B. gt_time_not_created */
    readonly code: string

    /** Meldung für den Toast */
    readonly toast: string

    /** HTTP-Status */
    readonly status: number

    /**
     * @param payload Geparster Response-Body (WP_Error-Struktur).
     * @param status  HTTP-Statuscode.
     */
    constructor( payload: any, status: number ) {
        super( payload?.message ?? `HTTP ${status}` )

        this.name   = 'Api_Error'
        this.code   = payload?.code ?? 'gt_unknown_error'
        this.toast  = payload?.data?.toast ?? 'Es ist ein Fehler aufgetreten.'
        this.status = status

        Object.setPrototypeOf( this, Api_Error.prototype )
    }

    /** Prüft, ob der Fehler auf eine abgelaufene Session hindeutet. */
    is_auth_error(): boolean {
        return this.status === 401 || this.status === 403 || this.code === 'rest_cookie_invalid_nonce'
    }
}

/**
 * Behandelt einen Fehler aus einer REST-Anfrage.
 *
 * @param error Der geworfene Fehler.
 * @param task  Beschreibung dessen, was fehlgeschlagen ist.
 */
export function handle_api_error( error: unknown, task: string ): void {
    console.error( `[Error] ${task}`, error )

    const detail = error instanceof Api_Error ? error.toast : ''

    app.show_toast_ajax_response( `Es gab ein Problem: ${task}. ${detail}`.trim(), 'error' )

    if ( app.is_debug_enabled() && error instanceof Api_Error ) {
        app.show_toast_ajax_response( `[${error.code}] ${error.message}`, 'error' )
    }
}


